﻿export class FileUploadUnregistered {
    static eventName() { return 'FileUploadUnregistered'; }
    eventName = FileUploadUnregistered.eventName;
    constructor(public transferId: string) { }
}